module.exports = __webpack_public_path__ + "img/nz.262bdd4f.svg";